var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{staticStyle:{"height":"290px","width":"550px"},attrs:{"id":"main"}})])
}]

export { render, staticRenderFns }